import React, { useEffect } from 'react'
import { createNativeStackNavigator } from '@react-navigation/native-stack'
import { Platform } from 'react-native'
import Constants from 'expo-constants'
import { NavigationContainer } from '@react-navigation/native'
import { PinchViewProvider } from 'react-native-pinch-view'

import NavigationStack from './NavigationStack'
import { ReelsViewer } from '../../posts/ReelsViewer'
import { CourseProvider } from '../../learning/CourseContext'
import {
    ConnectionState,
    ThemeProvider,
    ButtonDownloadContextProvider,
} from '../../appBar/context/HeaderContext'
import { GoToState } from '../../appBar/context/GoToContext'
import { WebSocketProvider } from '../../appBar/context/WebSocketContext'
import { useUrlWebSocket } from '../../../redux/zustand/webSocketUrl'
import { LocationState } from '../../appBar/context/LocationContext'
import {
    FormContextProvider,
    FormRefrigeratorContextProvider,
} from '../../stores/context/form.context'
import { PodcastContext, PodcastProvider } from '../../appBar/context/PodcastContext'
import { StoreContextProvider } from '../../stores/context/store.context'
import { BottomSheetProvider } from '../../customUtils/context/BottomSheetContext'
import { PostContextProvider } from '../../posts/context/posts.context'

import { DataState } from '../../appBar/context/HeaderContext'
import { AlertsState } from '../../appBar/context/AlertsContext'
import { navigationRef, flushNavigationQueue } from '../hooks/RootNavigation'
import { GamificationProvider } from '../../gamification/context/gamification.context'

const Stack = createNativeStackNavigator()

const APP_TITLE = Constants.expoConfig?.name

function NavigationMain({ wsUrlProp }) {
    const { urlWebSocket } = useUrlWebSocket()

    const effectiveWsUrl = wsUrlProp || urlWebSocket
    const [route, setRoute] = React.useState(null)
    const routeNameRef = React.useRef(null)

    // Web fallback: incluir NavigationContainer para web también
    if (Platform.OS === 'web') {
        return (
            <WebSocketProvider apiUrlSocket={effectiveWsUrl}>
                <DataState>
                    <PostContextProvider>
                        <ConnectionState>
                            <ButtonDownloadContextProvider>
                                <PodcastProvider>
                                    <LocationState>
                                        <GoToState>
                                            <NavigationContainer
                                                ref={navigationRef}
                                                onReady={flushNavigationQueue}
                                                onStateChange={() => {
                                                    // Cada vez que cambia la pantalla, scrollea al tope
                                                    window.scrollTo(0, 0)
                                                }}
                                                {...(Platform.OS === 'web' && {
                                                    documentTitle: {
                                                        formatter: (
                                                            options,
                                                            route,
                                                        ) => {
                                                            return APP_TITLE
                                                        },
                                                    },
                                                })}
                                            >
                                                <PinchViewProvider>
                                                    <ThemeProvider>
                                                        <CourseProvider>
                                                            <StoreContextProvider>
                                                                <FormRefrigeratorContextProvider>
                                                                    <FormContextProvider>
                                                                        <BottomSheetProvider>
                                                                            <GamificationProvider>
                                                                                <NavigationStack />
                                                                            </GamificationProvider>
                                                                        </BottomSheetProvider>
                                                                    </FormContextProvider>
                                                                </FormRefrigeratorContextProvider>
                                                            </StoreContextProvider>
                                                        </CourseProvider>
                                                    </ThemeProvider>
                                                </PinchViewProvider>
                                            </NavigationContainer>
                                        </GoToState>
                                    </LocationState>
                                </PodcastProvider>
                            </ButtonDownloadContextProvider>
                        </ConnectionState>
                    </PostContextProvider>
                </DataState>
            </WebSocketProvider>
        )
    }
    return (
        <WebSocketProvider apiUrlSocket={effectiveWsUrl}>
            <DataState route={route}>
                <PostContextProvider>
                    <ConnectionState>
                        <ButtonDownloadContextProvider>
                            <PodcastProvider>
                                <LocationState>
                                    <GoToState>
                                        <NavigationContainer
                                            ref={navigationRef}
                                            onReady={() => {
                                                flushNavigationQueue()
                                                routeNameRef.current =
                                                    navigationRef.getCurrentRoute()?.name
                                            }}
                                            onStateChange={() => {
                                                const newRouteName =
                                                    navigationRef.getCurrentRoute()
                                                        ?.name

                                                if (
                                                    routeNameRef.current !==
                                                    newRouteName
                                                ) {
                                                    setRoute(newRouteName)
                                                }

                                                routeNameRef.current = newRouteName
                                            }}
                                        >
                                            <PinchViewProvider>
                                                <ThemeProvider>
                                                    <CourseProvider>
                                                        <StoreContextProvider>
                                                            <FormRefrigeratorContextProvider>
                                                                <FormContextProvider>
                                                                    <BottomSheetProvider>
                                                                        <GamificationProvider>
                                                                            <Stack.Navigator
                                                                                screenOptions={{
                                                                                    headerShown: false,
                                                                                }}
                                                                            >
                                                                                <Stack.Screen
                                                                                    name='Main'
                                                                                    component={
                                                                                        NavigationStack
                                                                                    }
                                                                                />
                                                                                <Stack.Screen
                                                                                    name='ReelsViewer'
                                                                                    component={
                                                                                        ReelsViewer
                                                                                    }
                                                                                    options={{
                                                                                        animation:
                                                                                            'slide_from_bottom',
                                                                                    }}
                                                                                />
                                                                            </Stack.Navigator>
                                                                        </GamificationProvider>
                                                                    </BottomSheetProvider>
                                                                </FormContextProvider>
                                                            </FormRefrigeratorContextProvider>
                                                        </StoreContextProvider>
                                                    </CourseProvider>
                                                </ThemeProvider>
                                            </PinchViewProvider>
                                        </NavigationContainer>
                                    </GoToState>
                                </LocationState>
                            </PodcastProvider>
                        </ButtonDownloadContextProvider>
                    </ConnectionState>
                </PostContextProvider>
            </DataState>
        </WebSocketProvider>
    )
}
export default NavigationMain
